(function () {
  angular.module('MktzapApp.Factories')
    .factory('RiskListService', RiskListService);

    RiskListService.$inject = ['$resource'];

  function RiskListService ($resource) {
    return $resource('', {}, {
      save: { url: frontUrl + '/risk-list/save', method: 'POST', isArray: false },
      getBlocked: { url: frontUrl + '/risk-list/getBlocked', method: 'GET', isArray: false },
      removeBlock: { url: frontUrl + '/risk-list/removeBlock', method: 'POST', isArray: false },
    });
  }
})();
